import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import Slide from '@material-ui/core/Slide';
import {Paper, IconButton} from '@material-ui/core/';
import Maindescription from './Maindescription';
import Helstdescription from './Helstdescription';
import Hoijardescription from './Hoijardescription';
import Orangerietdescription from './Orangerietdescription';
import Appeldalendescription from './Appeldalendescription';
import Valloniadescription from './Valloniadescription';


import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles((theme) => createStyles({
    sectionTitle: {
      margin: theme.spacing(3, 2),
    },
    paper: {
        width: '20%',
        top: '80px',
        height: 'calc(100% - 80px - 70px)', // 145px is the 125px bottom area + 20px clearance
        padding: theme.shape.borderRadius, // ensures we clear the border radius
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        display: "flex",
        flexDirection: 'column',
        position: 'absolute',
        left: 0,
        backgroundColor: (theme.palette.type==="light") ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.6)',
        maxHeight: '85%',
        overflow: 'hidden'
    },
    description: {
        overflowY: "auto",
        flex: 1,
    },
    navcontrols: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    navButton: {
        width: "50%",
    }
  }));

export const ViewDescription = (props) => {
    //todo, don't keep several lists of what is what, keep one central 1 = display, 2 = pv etc.
    const classes = useStyles();

    let content = <div></div>
    switch (props.view) {
        case 0:
            content = <Maindescription />
            break;
        case 1:
            content = <Helstdescription />
            break;
        case 2:
            content = <Hoijardescription />
            break;
        case 3:
            content = <Valloniadescription />
            break;
        case 4:
            content = <Orangerietdescription />
            break;
        case 5:
            content = <Appeldalendescription />
            break;

        default:
            content = <div>wat</div>
            break;
    }
    if (content==null) {
        return <></>
    }
    //Todo, show some description of the next/back content, e.g. next button would have "Läs mer on ventilation" or plain "Ventilation"
    return <div>
        <Slide direction="right" in={true}>
        <Paper className={classes.paper} elevation={2}>
            <div className={classes.description}>{content}</div>
            <div className={classes.navcontrols}>
                <IconButton className={classes.navButton} aria-label="back" onClick={props.prevView}><ArrowBackIcon/></IconButton>
                <IconButton className={classes.navButton} aria-label="next" onClick={props.nextView}><ArrowForwardIcon/></IconButton>
            </div>
        </Paper>
    </Slide>
    </div>
}